/**
 * Alineado con stem-web-backend `security/customRoleFeatureKeys.ts`.
 */
export const CustomRoleFeatureKeys = {
  taskReopen: 'taskReopen',
  taskEditClosed: 'taskEditClosed',
  taskReassign: 'taskReassign',
  taskPdfDownload: 'taskPdfDownload',
  taskRespondOverdue: 'taskRespondOverdue',
  taskValidatorAssignable: 'taskValidatorAssignable',
  taskSubmitDraftOnly: 'taskSubmitDraftOnly',
  taskReadBroad: 'taskReadBroad',
  reportCalidadDetenciones: 'reportCalidadDetenciones',
  reportDetenciones: 'reportDetenciones',
  reportCalidadPhsv: 'reportCalidadPhsv',
  reportParametrosFijosKpi: 'reportParametrosFijosKpi',
  reportIngresoMateriaPrima: 'reportIngresoMateriaPrima',
  reportConsumosPlanta: 'reportConsumosPlanta',
  taskPdfQualityScoreColumns: 'taskPdfQualityScoreColumns',
  taskPdfPhotoDateStamp: 'taskPdfPhotoDateStamp',
  taskPdfMultiCheckboxSelectedOnly: 'taskPdfMultiCheckboxSelectedOnly',
  taskPdfBulkExportSamePedido: 'taskPdfBulkExportSamePedido',
  taskPdfModalPreviewColumnFilter: 'taskPdfModalPreviewColumnFilter',
  /**
   * Permisos equivalentes al rol fijo `kanbanAdmin` (órdenes de trabajo / Kanban).
   */
  taskKanbanGestor: 'taskKanbanGestor',
} as const;
